import LocalStorageService from 'src/services/LocalStorageService'

export const getAccountOfferStorageKey = (baseKey, userId) =>
  userId === null || userId === undefined || userId === ''
    ? null
    : `${baseKey}:${encodeURIComponent(String(userId))}`

export const removeLegacyOfferStorage = baseKey => {
  try {
    LocalStorageService.remove(baseKey)
    return true
  } catch (error) {
    return false
  }
}
